import type { FC } from "react";

import { Button } from "@recobra/ui/button";

import { useFormContext } from "./context";

export const SubmitButton: FC<{
  label: string;
  pendingLabel: string;
  disabled?: boolean;
  /** Shows the pending label while work outside the form submission, such as document processing, runs. */
  pending?: boolean;
}> = ({ label, pendingLabel, disabled = false, pending = false }) => {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <Button type="submit" disabled={isSubmitting || pending || disabled}>
          {isSubmitting || pending ? pendingLabel : label}
        </Button>
      )}
    </form.Subscribe>
  );
};
